import React from "react";

const AUTH_ERROR_PATTERNS = [
  /401/,
  /403/,
  /unauthorized/i,
  /forbidden/i,
  /invalid token/i,
  /token expired/i,
  /jwt expired/i,
  /not authenticated/i,
];

const CHUNK_ERROR_PATTERNS = [
  /loading chunk/i,
  /failed to fetch/i,
  /dynamically imported module/i,
  /cannot find module/i,
];

function isAuthError(error) {
  const msg = error?.message || error?.toString() || "";
  return AUTH_ERROR_PATTERNS.some((p) => p.test(msg));
}

function isChunkError(error) {
  const msg = error?.message || error?.toString() || "";
  return CHUNK_ERROR_PATTERNS.some((p) => p.test(msg));
}

function logout() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/";
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this._autoTimer = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);

    try {
      const errLog = {
        time: new Date().toISOString(),
        path: window.location.pathname,
        message: error?.message || String(error),
        stack: error?.stack?.slice(0, 500),
        component: info?.componentStack?.slice(0, 500),
      };
      localStorage.setItem('__eb_last_error', JSON.stringify(errLog));
    } catch (_) {}

    if (isAuthError(error)) {
      logout();
      return;
    }

    if (isChunkError(error)) {
      window.location.reload();
      return;
    }
  }

  componentWillUnmount() {
    clearTimeout(this._autoTimer);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <p>Something went wrong. Please <button onClick={() => window.location.reload()} style={{ cursor: "pointer", textDecoration: "underline", background: "none", border: "none", color: "inherit" }}>reload the page</button>.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
